export const checkIfMxCL = marketConfig => {
    const olxAutos = marketConfig.get('olxAutos');

    return !!(olxAutos && olxAutos.isMXCL);
};
